<template>
  <div class="works container">
    <works ref="detailWorks" :chapterInfo="info" />
  </div>
</template>

<script>
import works from "../classCourse/works.vue";
export default {
  components: {
    works,
  },
  props: {
    info: Object,
  },
};
</script>

<style lang="less" scoped>
.works {
  padding: 10px 0;
  height: 100%;
}
</style>